import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import styles from './styles.css';

interface ISlideshow {
    images: string[];
}

const Slideshow = (props: ISlideshow) => (
    <div>
        <Slide easing="ease" className={styles.slideshow}>
            {props.images.map((img, index) => (
                <div className={styles.eachSlide} key={index}>
                    <div style={{ backgroundImage: `url(${img})` }}></div>
                </div>
            ))}
        </Slide>
    </div>
);

export default Slideshow;
